import { render, staticRenderFns } from "./Kogl.vue?vue&type=template&id=971f21a8"
import script from "./Kogl.vue?vue&type=script&lang=js"
export * from "./Kogl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports